<template lang="pug">
    app-modal(
      :closeOutside="false",
      titulo="Visualizar dados do usuário",
      :width="1000",
      @closeModal="closeModal()",
      :hasFooter="false"
    )
      template(slot="body")
        app-divider(:label="isPessoaJuridica ? 'Pessoa Jurídica' : 'Pessoa Física'")
        el-row(:gutter="20")
          el-col(:span="12").margin-top
            app-display(
              :label="isPessoaJuridica ? 'Razão Social:' : 'Nome:'",
              :content="isPessoaJuridica ? usuario.pessoa.pessoaJuridica.razaoSocial : usuario.pessoa.nomeRazaoSocial"
            )
            app-display(
              :label="isPessoaJuridica ? 'CNPJ:' : 'CPF:'",
              :content="isPessoaJuridica ? usuario.pessoa.pessoaJuridica.cnpj : usuario.pessoa.pessoaFisica.cpf"
            )
            app-display-multiple(
              label="E-mail:",
              :content="usuario.pessoa.emails.map(email => email.dado)",
            )
            app-display-multiple(
              label="Telefones:",
              :content="usuario.pessoa.telefones.map(telefone => telefone.numero)",
            )
          el-col(v-if="isPessoaJuridica" :span="12").margin-top
            app-display(
              label="Nome Fantasia: ",
              :content="usuario.pessoa.pessoaJuridica.nomeFantasia"
            )
            app-display(
              label="Código CNAE (subclasse):",
              :content="!usuario.pessoa.pessoaJuridica.cnae.codigo ? '-' : usuario.pessoa.pessoaJuridica.cnae.codigo",
            )
            app-display(
              label="Nome da atividade conforme CNAE:",
              :content="!usuario.pessoa.pessoaJuridica.cnae.nomeAtividade ? '-' : usuario.pessoa.pessoaJuridica.cnae.nomeAtividade",
            )
            app-display(
              label="Ramo de atuação:",
              :content="!usuario.pessoa.pessoaJuridica.ramoAtuacao ? '-' : usuario.pessoa.pessoaJuridica.ramoAtuacao",
            )
          el-col(v-if="isPessoaJuridica" :span="12")
            app-display(
              label="Inscrição estadual:",
              :content="!usuario.pessoa.pessoaJuridica.inscricaoEstadual ? '-' : usuario.pessoa.pessoaJuridica.inscricaoEstadual",
            )

        app-divider.margin-top(label="Endereço")
        .margin-top
          el-row
            el-col(:span="12")
              app-display(label="CEP:", :content="endereco.cep")
            el-col(:span="12")
              app-display(label="Bairro:", :content="endereco.bairro")

          el-row
            el-col(:span="12")
              app-display(label="Logradouro:", :content="endereco.logradouro")
            el-col(:span="12")
              app-display(label="Número:", :content="endereco.semNumero ? 'S/N' : endereco.numero")

          el-row
            el-col(:span="12")
              app-display(label="Município:", :content="endereco.municipio.nome")
            el-col(:span="12")
              app-display(label="UF:", :content="endereco.municipio.codigoEstado")

        app-display(label="Complemento:", :content="!endereco.complemento ? '-' : endereco.complemento")

        app-divider(label="Dados do usuário")
        .margin-top.margin-bottom
          app-display(label="Situação:", :content="situacao")
          app-display(
            :label="usuario.perfis.length > 1 ? 'Perfis:' : 'Perfil:'",
            :content="perfis"
          )
          app-display(label="Órgão:" :content="!usuario.pessoa.orgao ? '-' : usuario.pessoa.orgao")
          app-display(v-if="usuario.municipioPrefeitura", label="Prefeitura:", :content="usuario.municipioPrefeitura.nome")

</template>

<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppDisplay from '@/components/AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppModal,
    AppLabel,
    AppDivider,
    AppDisplay,
    AppDisplayMultiple
  },

  props: {
    usuario: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      enderecoIterpa: {
        logradouro: 'ROD. AUGUSTO MONTENEGRO, KM 09',
        numero: null,
        semNumero: true,
        complemento: '',
        bairro: 'PARQUE GUARAJÁ',
        cep: '66821-000',
        municipio: {
          id: 1501402,
          codigoEstado: 'PA'
        }
      }
    }
  },

  methods: {

    closeModal () {
      this.isCamposModal = true
      this.$emit('closeModal')
    }

  },

  computed: {
    isPessoaJuridica () {
      return !!this.usuario.pessoa.pessoaJuridica
    },
    endereco () {
      return this.usuario.pessoa.enderecoCorrespondencia
    },

    situacao () {
      if (this.usuario.isBloqueado) {
        return 'Bloqueado'
      }
      return this.usuario.ativo ? 'Ativo' : 'Inativo'
    },
    perfis () {
      return this.usuario.perfis.reduce((acm, current, index) => {
        const isLast = index === this.usuario.perfis.length - 1
        return acm + current.nome + (isLast ? '' : ', ')
      }, '')
    }
  }

}
</script>

<style scoped lang="scss">
  .buttons {
    display: flex;
    justify-content: space-between;
  }

  .margin-top {
    margin-top: 10px;
  }

  .margin-right {
    margin-right: 10px;
  }

  .margin {
    margin-top: -10px;
  }

  .footer {
    height: 0px !important;
  }

  .margin-bottom {
    margin-bottom: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalVisualizarUsuario.vue